import styled from "styled-components";
import styledMap from "styled-map";

import theme from "config/theme";

import StyledIcon from "components/Icon";

export const Inner = styled.div`
  flex: 1;
  padding-bottom: 5px;
  border-top: 1px solid ${theme.color.paper2};

  @media (max-width: ${theme.size.tablet}) {
    padding-bottom: 0;
  }
`;

export const Icon = styled(StyledIcon)`
  margin: 40px 20px 0 0;
  color: ${props =>
    props.isVisible ? theme.color.primary : theme.color.gray4};

  margin: ${styledMap("size", {
    small: "22px 15px 0 0",
    default: "40px 20px 0 0"
  })};

  font-size: ${styledMap("size", {
    small: "0.8em",
    default: "1em"
  })};

  @media (max-width: ${theme.size.tablet}) {
    margin: ${styledMap("size", {
      small: "20px 15px 0 0",
      default: "27px 20px 0 0"
    })};
  }
`;

export const Title = styled.div`
  position: relative;
  width: 100%;
  color: ${theme.color.gray2};
  transition: ${theme.transition};

  font-size: ${styledMap("size", {
    small: theme.font.size.epsilon,
    default: theme.font.size.upsilon
  })};

  padding: ${styledMap("size", {
    small: "15px 0 5px",
    default: "30px 0 10px"
  })};

  @media (max-width: ${theme.size.tablet}) {
    padding-top: 20px;
    line-height: 1.4;
    font-size: ${theme.font.size.delta};

    padding-top: ${styledMap("size", {
      small: "15px",
      default: "20px"
    })};
  }
`;

export const Text = styled.div`
  overflow: hidden;
  opacity: ${props => (props.isVisible ? "1" : "0")};
  transition: ${props =>
    props.isVisible
      ? "max-height 1s ease-in-out, opacity 0.3s"
      : "max-height 0.5s cubic-bezier(0, 1, 0, 1), opacity 0.3s"};
  max-height: ${props => (props.isVisible ? "9999px" : "0px")};

  margin-bottom: ${styledMap("size", {
    small: "5px",
    default: "20px"
  })};

  font-size: ${styledMap("size", {
    small: theme.font.size.zeta,
    default: theme.font.size.epsilon
  })};

  color: ${styledMap("size", {
    small: theme.color.gray3,
    default: theme.color.gray2
  })};

  @media (max-width: ${theme.size.tablet}) {
    margin-bottom: 10px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  cursor: pointer;

  &:first-of-type ${Inner} {
    border-top: none;
  }

  &:hover {
    ${Icon} {
      color: ${theme.color.primary};
    }

    ${Title} {
      color: ${theme.color.gray};
    }
  }
`;
